import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService, NotificationService } from 'tms-lib';
import { TmsWebBaseEditCreateService } from '../../base';
import { SalesDiscountProductType } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SalesDiscountProductTypeService extends TmsWebBaseEditCreateService<
  SalesDiscountProductType,
  SalesDiscountProductType
> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('SalesDiscountProductType', $localize`Sales Discount Product Type`, httpService, notificationService);
  }
}
